export default class InstanceManager {
    private elementMap: Map<HTMLElement, Map<string, any>> = new Map();

    public set<T>(element: HTMLElement, key: string, instance: T) {
        if (!this.elementMap.has(element)) {
            this.elementMap.set(element, new Map())
        }

        const instanceMap = this.elementMap.get(element)!;

        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (instanceMap.has(key)) {
            console.error(`More than one instance are not alowed. Bound instance: ${Array.from(instanceMap.keys())[0]}.`)
            return;
        }

        instanceMap.set(key, instance)
    }

    public get<T>(element: HTMLElement, key: string = ''): T | null {
        if(this.elementMap.has(element) && this.elementMap.get(element)!.has(key)) {
            return this.elementMap.get(element)!.get(key);
        }
        return null;
    }

    public has(element: HTMLElement, key: string = ''): boolean {
        if(this.elementMap.has(element)) {
            if(key != '') {
                if(this.elementMap.get(element)!.has(key)) {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    }

    public remove(element: HTMLElement, key: string) {
        if (!this.elementMap.has(element)) {
            return
        }

        const instanceMap = this.elementMap.get(element)!;
        instanceMap.delete(key)

        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) {
            this.elementMap.delete(element)
        }

    }

    public getInstanceMap<T>(element: HTMLElement): Map<string, T>|undefined {
        return this.elementMap.get(element);
    }

    public getElementMap(): Map<HTMLElement, Map<string, any>> {
        return this.elementMap;
    }

    public getElementInstances(element: HTMLElement):  Map<string, any>|undefined {
        return this.elementMap.get(element);
    }
}
